import { getCreatorApiUrl } from '@client/components/api-urls';
import { removeSourceURL, tryReadSourceURL } from '@services/meta-pixel';
import { utmParams } from '@services/utms';
import axios from 'axios';

export interface RegistrationResponse {
  id: number;
  username: string;
  role: number;
  firstName: string;
  lastName: string;
  email: string;
  token: string;
  tokenExpiresAt: string;
  influencerId: number;
  influencer: any;
}

export type RegisterInput = {
  token: string;
  email: string;
  firstName: string;
  lastName: string;
  salesModel: string;
  profileInstagram: string;
};

export const register = async ({
  token,
  email,
  firstName,
  lastName,
  salesModel,
  profileInstagram,
}: RegisterInput): Promise<RegistrationResponse> => {
  const sourceURL = tryReadSourceURL();
  const utms = utmParams.restore();
  const response = await axios.post(getCreatorApiUrl('/creators/register'), {
    token,
    email,
    firstName,
    lastName,
    salesModel,
    profileInstagram,
    title: '',
    keywords: [],
    primaryColor: '',
    sourceURL,
    ...utms,
  });
  removeSourceURL();
  return response.data;
};
